import type { FC, ReactNode } from 'react';
import { SwiperSlide } from 'swiper/react';

export interface ScrollFrameItemProps {
  children?: ReactNode;
  value?: string;
}

const ScrollFrameItem: FC<ScrollFrameItemProps> = (p) => {
  const { children } = p;

  return <SwiperSlide>{children}</SwiperSlide>;
};
ScrollFrameItem.displayName = 'SwiperSlide';
export default ScrollFrameItem;
